import React from 'react'
import { useDevice } from 'device'

import BrandsQualityBlock from 'compositions/landings/BrandsQualityBlock/BrandsQualityBlock'

import GetStartedButton from '../GetStartedButton/GetStartedButton'


const BrandsSection: React.FunctionComponent = () => {
  const { isMobile } = useDevice()

  const button = (
    <GetStartedButton
      className={isMobile ? 'mt-24' : 'mt-32'}
      width={isMobile ? null : 280}
      fullWidthOnMobile
      placement="Brand block"
    />
  )

  return (
    <BrandsQualityBlock
      className={isMobile ? 'mt-72 pb-64' : 'mt-80'}
      button={button}
    />
  )
}


export default React.memo(BrandsSection)
